export const linksEng =[
    "https://www.swedishepa.se/Environmental-objectives-and-cooperation/Swedens-environmental-objectives/The-national-environmental-objectives/",
    "https://www.stockholmresilience.org/research/planetary-boundaries.html",
    "https://www.ipcc.ch/report/ar6/wg1/",
    "https://ukcop26.org/",
    ];